import { FC } from 'react'
import clsx from 'clsx'

import { PROD_STATIC_PATH } from 'constants/data'
import { OfferType } from './data'

import styles from './offer-aggre.module.scss'

interface IOfferAggre {
  btnName: string
  themeOffer?: string
  modificator?: string
}

const OfferAggre: FC<IOfferAggre> = ({ btnName, themeOffer = OfferType.STANDART, modificator }) => {
  return (
    <div
      className={clsx(styles.memo, {
        [styles.dark]: themeOffer === OfferType.DARK,
        [modificator as string]: modificator,
      })}
    >
      <p>
        Нажимая кнопку «{btnName}», я соглашаюсь с условиями&ensp;
        <a
          href={`${PROD_STATIC_PATH}/oferta_educational_services.pdf`}
          target="_blank"
          rel="noreferrer"
          className={styles.memoLink}
        >
          Оферты,
        </a>
        &ensp;а также принимаю&ensp;
        <a
          href={`${PROD_STATIC_PATH}/terms.pdf`}
          target="_blank"
          rel="noreferrer"
          className={styles.memoLink}
        >
          Пользовательское соглашение
        </a>
        &ensp;и&ensp;
        <a
          href={`${PROD_STATIC_PATH}/privacy.pdf`}
          target="_blank"
          rel="noreferrer"
          className={styles.memoLink}
        >
          Политику
        </a>
      </p>
    </div>
  )
}

export default OfferAggre
